import { FETCH_INGREDIENTS } from "../actions/types";

const ingredients = (state = [], action) => {
  switch (action.type) {
    case FETCH_INGREDIENTS:
      return action.payload;
    default:
      return state;
  }
};

export default ingredients;
